/** Знак AutoAFF: «двойная стрелка вперёд» — автоматический ход. */
export function Mark() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 7l5 5-5 5" />
      <path d="M13 7l5 5-5 5" />
    </svg>
  );
}
